<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2298_8150)">
<rect x="4.7" y="3.7" width="28.6" height="22.6" rx="1.8" stroke="currentColor" stroke-width="1.4"/>
<rect width="1.4" height="34.0963" rx="0.7" transform="matrix(0.370033 0.929018 -0.812893 0.582413 32.5151 4.52173)" fill="currentColor"/>
<rect width="1.4" height="33.6281" rx="0.7" transform="matrix(0.393743 -0.919221 0.79768 0.603081 5.22803 5.60449)" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2298_8150">
<rect width="38" height="30" fill="white"/>
</clipPath>
</defs>
</svg>
